import React from 'react'
import PlanTabsPostpaid from '../../../public/activation/PostPaid/PlanTabs'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PostPaidAddPaymentMethod from '../PostPaidAddPaymentMethod';
import MyPayments from '../../MyPayments';
import PlanTabs from "../../PostPaid/wmeServiceMigration/PlanTabs"
import axios from 'axios';
import { getApiHeader } from '../../../../utils/CommonFunctions';
import swal from '@sweetalert/with-react';
import PageLoader from '../../../Loader/loader';





function WmeServiceMigration() {
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [model_visibility, setModelVisibility] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const mobileNumber = sessionStorage.getItem("migration-number")
    const[sessionId,setSessionId]=React.useState("")


    const goNextStep = async (plan) => {

        try {
            let headers = await getApiHeader();
            setLoading(true)
            let params = {
                plan_id: plan.plan_id,
                mobile_number: mobileNumber,
                session_id:sessionId,
            }

            const response = await axios.post(`${SERVER_URL}postpaid/so-wp-da-al`, params, { headers })
            const message = response.data?.message;
             
            if (response.status === 200) {
                setLoading(false)
               
                const finalSessionId = sessionId || response.data.data?.session_id;

                if (!sessionId) {
                    setSessionId(finalSessionId)
                }


                const data = {
                    session_id: finalSessionId,
                    plan_id: plan.plan_id,
                    mobile_number: mobileNumber
                }

                swal({
                    title: "Do you wish to continue",
                    text: typeof message === "string" ? message : JSON.stringify(message),
                    icon: "warning",
                    buttons: {
                        confirm: {
                            text: "OK, Proceed",
                            value: true,
                            closeModal: true,
                        },
                        cancel: {
                            text: "No, Cancel",
                            value: null,
                            visible: true,
                            closeModal: true,
                        },
                        
                    },
                }).then((value) => {
                    if (value) {
                        callBackPayment(data);
                    }
                });
            }

        } catch (error) {
            setLoading(false)
            const message = error.response.data?.message
                   swal({
                    title: "error",
                    text: typeof message === "string" ? message : JSON.stringify(message),
                    icon: "error",
                }).then(() => {
                      window.location.href = "/my-service-list"; 
                });
        }
    }

    const callBackPayment = async (result) => {

        try {
            setLoading(true)
            let headers = await getApiHeader();
            const response = await axios.post(`${SERVER_URL}postpaid/so-wp-pr-cp`, result, { headers })

            let message = response.data.message
            if (response.status === 200) {
                setLoading(false)

                swal({
                    title: "Success",
                    text: typeof message === "string"
                        ? message
                        : JSON.stringify(message),
                    icon: "success"
                }).then(() => {
                    window.location.href = "/my-service-list";
                });
                sessionStorage.removeItem("migration-number")
            }

        } catch (error) {
            setLoading(false)
              let message = error.response.data.message
             swal({
                    title: "error",
                    text: typeof message === "string"
                        ? message
                        : JSON.stringify(message),
                    icon: "error"
                })
                
        }
    }










    return (
        <>
            {(loading === true) ? <PageLoader /> : null}

            <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor common-class" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="row">
                        <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
                            <Modal className="modal-fullscreen" size='lg' show={model_visibility} onHide={() => setModelVisibility(false)}>
                                <form onSubmit={""}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Add Payment Method</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                                 < PostPaidAddPaymentMethod onlyPayment={true} callBackPayment={callBackPayment} />
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => setModelVisibility(false)}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </form>
                            </Modal>
                            <div>
                                <PlanTabs from="add-mobile-plan" goNextStep={goNextStep} />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default WmeServiceMigration






















